<template>
    <div class="float-left mr-1">
        <span class="text-success" v-if="manutencao.status === 1">
            <i
                class="fa fa-toggle-on fa-lg icon-button"
                title="Desativar Item"
                @click.stop="confirmaAtivarDesativarItem('D')"
            ></i>
        </span>
        <span class="text-secondary" v-if="manutencao.status === 0">
            <i
                class="fa fa-toggle-off fa-lg icon-button"
                title="Ativar Item"
                @click.stop="confirmaAtivarDesativarItem('A')"
            ></i>
        </span>
    </div>
</template>

<script>
import ManutencaoServicos from './ManutencoesContratosServicos'

export default {
    props: {
        manutencao: {
            type: Object,
            default: () => ({})
        },
        idManutencaoContrato: {
            type: String,
            default: () => ({})
        },
        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmaAtivarDesativarItem(operacao) {
            let titulo = `${
                operacao === 'A' ? 'Ativação' : 'Desativação'
            } de Item`
            let mensagem = `Confirma a ${
                operacao === 'A' ? 'ativação' : 'desativação'
            } da Melhoria/Manutenção de descrição ${this.manutencao.descricao}?`

            this.$swal({
                title: titulo,
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let manutencaoDto = {
                contratoId: this.manutencao.idContrato,
                dataInicio: this.manutencao.dataInicio,
                dataFim: this.manutencao.dataFim,
                descricao: this.manutencao.descricao,
                status: this.manutencao.status == 1 ? 0 : 1,
            }

            let promisse
            manutencaoDto = { ...manutencaoDto, idManutencaoContrato: this.idManutencaoContrato }
            promisse = ManutencaoServicos.atualizar(this.contrato.idContrato, this.idManutencaoContrato, manutencaoDto)

            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Operação realizada com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterManutencoesAtualizadas')
        },
    },
    
    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
